// string-replace [someVar] with provided values

import { format } from 'date-fns'
import {
  UserModel,
  UserModelSelf
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { userFields } from './userFields'
import moment from 'moment'

// TODO migrate all certs to [] variables, then we can use the same function for both
export const interpolateCertificates = (
  str: string,
  vars: { [k: string]: any }
) =>
  str.replace(/{{([^{}]*)}}/g, (match, varName: string) => {
    const v = vars[varName]
    return typeof v === 'string' || typeof v === 'number' ? `${v}` : match
  })

// TODO we need to handle null values here for now, but it would be nicer to have DB defaults for all fields so that we don't have to do it
export const interpolate = (str: string | null, vars: { [k: string]: any }) => {
  return (
    str?.replace(/\[([^\[\]]*)\]/g, (match, varName: string) => {
      const v = vars[varName]

      if (v instanceof Date) {
        return format(v, 'yyyy-MM-dd')
      }
      return typeof v === 'undefined' ? match : `${v}`
    }) ?? ''
  )
}

export const interpolateWithUserVars = (
  tpl: string,
  user: Partial<UserModel> | Partial<UserModelSelf> | null | undefined
): string => {
  if (!user) {
    return ''
  }
  const vars = Object.fromEntries([
    ...userFields.map((f) => [`person_${f}`, user[f] ?? '']),
    ...userFields.map((f) => [`manager_${f}`, user['manager']?.[f] ?? '']),

    ['current_date', moment().format('DD/MM/YYYY')]
  ])

  return interpolate(tpl, vars)
}
